import qs from 'qs';

import isNil from 'utils/is-nil';

const ROOT = '/';
const BASE = '/search';

export const ROUTES = {
    ROOT: () => ROOT,
    SEARCH: () => BASE,
    TYPE: ({ page, typeName, order }) =>
        [BASE, 'types', typeName, order, page && `page/${page}`].filter(Boolean).join('/'),
    VENDORS: ({ page, letter }) =>
        [BASE, 'vendors', letter && `index/${letter}`, page && `page/${page}`].filter(Boolean).join('/'),
    VENDOR: ({ page, vendorName, score = null, year = null, month = null }) => {
        const search = qs.stringify(
            { score, year, month },
            { addQueryPrefix: [score, year, month].some((value) => !isNil(value)), skipNulls: true }
        );
        return [BASE, 'vendors', vendorName, page && `page/${page}`].filter(Boolean).join('/') + search;
    },
    VENDOR_CVE: ({ page, vendorName, score = null, year = null, month = null }) => {
        const search = qs.stringify(
            { score, year, month },
            { addQueryPrefix: [score, year, month].some((value) => !isNil(value)), skipNulls: true }
        );
        return [BASE, 'vendors', vendorName, 'cve', page && `page/${page}`].filter(Boolean).join('/') + search;
    },

    PRODUCTS: ({ page, letter }) =>
        [BASE, 'products', letter && `index/${letter}`, page && `page/${page}`].filter(Boolean).join('/'),
    VENDOR_PRODUCT: ({ page, vendorName, productName, score = null, year = null, month = null }) => {
        const search = qs.stringify(
            { score, year, month },
            { addQueryPrefix: [score, year, month].some((value) => !isNil(value)), skipNulls: true }
        );

        return (
            [BASE, 'vendors', vendorName, 'products', productName, page && `page/${page}`].filter(Boolean).join('/') +
            search
        );
    },
    YEARS: ({ page, year, month }) =>
        [BASE, 'years', year && `year/${year}`, month && `month/${month}`, page && `page/${page}`]
            .filter(Boolean)
            .join('/'),
    CVSS: ({ page, cvss }) => [BASE, 'cvss', cvss && `score/${cvss}`, page && `page/${page}`].filter(Boolean).join('/')
};

export const NONE = '—';
